const translations = {
  groups: 'Groups',
  createNewGroup: 'Create new group',
  myGroups: 'MY GROUPS',
  group1: 'Class A1',
  group2: 'My other students',
};

export default translations;
